module.exports = __webpack_public_path__ + "static/media/tatwertechlogo.79fd7964.png";